<template>
  <div v-loading="loading">
    <div class="invoice" :class="{'no-fixed-height': invoice}" v-if="!loading">
      <div class="header">
        <h1 class="invoice-title">Invoice <span v-if="_invoice.paid">Paid <i class="el-icon-check" /></span></h1>
        <img src="@/assets/logo_all_blue.png" class="logo" />
      </div>
      <el-row :gutter="20">
        <el-col :span="12" class="info">
          <h1>{{ _invoice.organization.name }}</h1>
          <p>{{ _invoice.organization.address }}</p>
          <p>{{ _invoice.organization.zip }} {{ _invoice.organization.city }}</p>
          <p>{{ _invoice.organization.country.name }}</p>
          <p class="splitter">{{ _invoice.organization.phoneNumber }} </p>
        </el-col>
        <el-col :span="12" class="info right">
          <h1>Divegas</h1>
          <p>Someaddress 23</p>
          <p>8000 Aarhus</p>
          <p>Denmark</p>
          <p class="splitter">+45 99 99 99 99</p>
          <p>CVR: 00 00 00 00</p>
        </el-col>
      </el-row>
      <div class="invoice-info">
        <p>Invoice no. {{ _invoice.invoiceId }}</p>
        <p>Billing period {{ _invoice.from | simpleDate }} - {{ _invoice.to | simpleDate }}</p>
        <p>Billing date {{ _invoice.createdAt | simpleDate }}</p>
        <p>Due date {{ invoice.dueDate | simpleDate }}</p>
      </div>
      <div class="items">
        <div class="item" v-for="item in _invoice.items" :key="item.id">
          {{ item.description }}
          <span>{{ item.amount.toFixed(2) }} {{ item.currency }}</span>
        </div>
        <div class="item total">
          Total
          <span>{{ _invoice.total.toFixed(2) }} {{ _invoice.organization.currency.name }}</span>
        </div>
      </div>
      <div class="cc-info" v-if="_invoice.paid">
        Paid with {{ _invoice.creditCardBrand }} ending in {{ _invoice.creditCardLast4 }} expires at {{ _invoice.creditCardExp }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Invoice',
  props: {
    invoice: Object
  },
  data () {
    return {
      loading: true,
      _invoice: {
        organization: {
          country: {},
          currency: {}
        },
        items: []
      }
    }
  },
  watch: {
    invoice () {
      this._invoice = this.invoice
    }
  },
  methods: {
    async getInvoice () {
      const id = this.$route.params.id
      const response = await this.$http.get(this.$api.invoices.get(id))
      this._invoice = response.data
      this.loading = false
    }
  },
  created () {
    if (!this.invoice) {
      this.getInvoice()
    } else {
      this.loading = false
      this._invoice = this.invoice
    }
  }
}
</script>

<style lang="scss" scoped>
  .cc-info {
    padding-top: 40px;
    color: $text;
    font-size: 14px;
  }

  .invoice-title {
    display: flex;
    flex-direction: column;

    span {
      display: block;
      background-color: $main;
      color: white;
      padding: 7px 5px;
      text-align: center;
      font-size: 16px;
      text-transform: uppercase;
    }
  }

  .invoice-info {
    margin-top: 80px;
    color: $text;
    font-size: 14px;

    p {
      margin: 0;
      margin-bottom: 5px;

      &:first-child {
        margin-bottom: 15px;
      }

      &:last-of-type {
        margin-bottom: 0px;
      }
    }
  }

  .items {
    margin-top: 40px;
    border-top: 1px solid $border;
    padding-top: 40px;
  }

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $text;
    font-size: 14px;
    margin-bottom: 10px;

    &.total {
      border-top: 1px solid $border;
      border-bottom: 1px solid $border;
      padding: 40px 0px;
      margin-top: 40px;
      font-weight: 600;
      font-size: 18px;
    }
  }

  .splitter {
    padding: 20px 0px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 100px;

    h1 {
      font-size: 32px;
      color: $text;
      font-weight: 600;
    }
  }

  .invoice {
    padding: 80px;
    height: 100vh;
    box-sizing: border-box;
    overflow-y: scroll;

    &.no-fixed-height {
      height: auto;
      overflow-y: visible;
      padding: 80px;
    }
  }

  .info {
    h1 {
      color: $text;
      font-size: 14px;
      font-weight: 600;
    }

    p {
      color: $text;
      font-size: 14px;
      margin: 0;
    }

    &.right {
      p, h1 {
        text-align: right !important;
      }
    }
  }

  .logo {
    width: 100px;
    height: auto;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/front/invoice/Invoice.vue